import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import CallbackDialog from "@/components/CallbackDialog";
import { Search } from "lucide-react";

const CATS = [
  { key: "all", label: "All Products" },
  { key: "personal", label: "Personal" },
  { key: "bike", label: "Two-Wheeler" },
  { key: "obd", label: "OBD Plug & Play" },
  { key: "fleet", label: "Fleet" },
  { key: "commercial", label: "Commercial" },
];

export default function Products() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("all");
  const [q, setQ] = useState("");
  const [sort, setSort] = useState("featured");
  const [cbOpen, setCbOpen] = useState(false);
  const [cbProduct, setCbProduct] = useState(null);

  useEffect(() => {
    const params = {};
    if (cat !== "all") params.category = cat;
    if (q) params.q = q;
    api.get("/products", { params }).then((r) => setProducts(r.data)).catch(() => {});
  }, [cat, q]);

  const sorted = [...products].sort((a, b) => {
    if (sort === "price-asc") return (a.price || 0) - (b.price || 0);
    if (sort === "price-desc") return (b.price || 0) - (a.price || 0);
    if (sort === "name") return a.name.localeCompare(b.name);
    return 0;
  });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="products-page">
      <div className="max-w-3xl">
        <div className="eyebrow">GPS devices catalogue</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">Choose the right GPS tracker</h1>
        <p className="mt-4 text-slate-600">From personal cars to enterprise fleets — every KSPB device comes with warranty, professional installation and dedicated Indian support.</p>
      </div>

      <div className="mt-10 flex flex-col md:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search devices…"
            className="w-full h-12 pl-10 pr-4 rounded-full border border-slate-200 focus:border-[#FF6D00] outline-none"
            data-testid="product-search"
          />
        </div>
        <select value={sort} onChange={(e) => setSort(e.target.value)} className="h-12 px-4 rounded-full border border-slate-200 bg-white outline-none" data-testid="product-sort">
          <option value="featured">Featured</option>
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
          <option value="name">Name (A-Z)</option>
        </select>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {CATS.map((c) => (
          <button key={c.key} onClick={() => setCat(c.key)} data-testid={`cat-${c.key}`}
            className={`px-4 h-10 rounded-full text-sm font-medium border transition-colors ${cat === c.key ? "bg-[#0A192F] text-white border-[#0A192F]" : "bg-white text-slate-700 border-slate-200 hover:border-[#0A192F]"}`}>
            {c.label}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {sorted.map((p) => <ProductCard key={p.id} product={p} onCallback={(pp) => { setCbProduct(pp); setCbOpen(true); }} />)}
      </div>

      {sorted.length === 0 && (
        <div className="mt-16 text-center text-slate-500">No products match your search.</div>
      )}

      <CallbackDialog open={cbOpen} onOpenChange={setCbOpen} product={cbProduct} />
    </div>
  );
}
